export type FeedbackParams = {
	email?: string;
	platform: string;
	appLanguage: string;
	sessionId?: string;
	tenantId?: string;
	itemId?: string;
	itemVersionId?: string;
	sessionType?: string;
	currentAppVersion?: string;
	type?: "Review" | "Deletion" | "Feature" | "Content Flagged";
	context?: string;
	feature?: "AI Session Analysis" | "AI QA";
	bundleId?: number;
	bundleName?: string;
	product?: string;
	companyName?: string;
	view?: string;
	runId?: string;
	projectId?: number;
	organizationId?: number;
	productId?: number;
	userName?: string;
	appName?: string;
	rating?: "positive" | "negative";
};
